import React from 'react';
import { motion } from 'framer-motion';
import { Users, BookOpen, Layout, Layers } from 'lucide-react';
import { useTranslation } from '../i18n/LanguageContext';
import { PersonaLibrary } from './PersonaLibrary';
import { PersonaEditor } from './PersonaEditor';
import { PanelBuilder } from './PanelBuilder';
import { ArchetypeGallery } from './ArchetypeGallery';

export function PersonasTab({ library }) {
  const { t } = useTranslation();

  const subNavItems = [
    { key: 'library', label: t('personaLib.navLibrary'), icon: BookOpen },
    { key: 'panel-builder', label: t('personaLib.navPanelBuilder'), icon: Layout },
    { key: 'archetypes', label: t('personaLib.navArchetypes'), icon: Layers },
  ];

  return (
    <div className="space-y-6">
      {/* Sub-navigation */}
      {library.subView !== 'editor' && (
        <div className="flex gap-2 bg-white rounded-xl p-1.5 shadow-sm border border-stone-200 w-fit">
          {subNavItems.map(item => (
            <button
              key={item.key}
              onClick={() => library.setSubView(item.key)}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                library.subView === item.key
                  ? 'bg-amber-100 text-amber-800'
                  : 'text-stone-500 hover:text-stone-700 hover:bg-stone-50'
              }`}
            >
              <item.icon className="w-4 h-4" />
              {item.label}
            </button>
          ))}
        </div>
      )}

      {/* Sub-view content */}
      {library.subView === 'library' && <PersonaLibrary library={library} />}
      {library.subView === 'editor' && <PersonaEditor library={library} />}
      {library.subView === 'panel-builder' && <PanelBuilder library={library} />}
      {library.subView === 'archetypes' && <ArchetypeGallery library={library} />}
    </div>
  );
}
